export type Params = {
    attributeName: string,
    attributeId: number,
};

export const createAttributeRoutePath = (params: Params) => {
    return `/attributes/${params.attributeId}/${params.attributeName}`;
};
